import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";

const CustomRadio = withStyles({
  root: {
    color: "#9240C9",
    "&$checked": {
      color: "#9240C9",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

export default function RadioButtons({ checked, handleChange }) {
  return (
    <div>
      <CustomRadio checked={checked} onClick={handleChange} />
    </div>
  );
}
